import EsaedroResourceFilter from "../Models/EsaedroResourceFilter";
import ResourceField from "../Models/ResourceField";

import FormatTypes from "./FormatTypes";
import { FormField } from "../Models/SysConf/FormField";
import FieldTypes from "./FieldTypes";
import { Form } from "../Models/SysConf/Form";
import { FormGroup } from "../Models/SysConf/FormGroup";
import UserProfile from "../Models/UserProfile";
import { ResourceViewField } from "../Models/SysConf/ResourceViewField";
import EsaedroSortField from "../Models/EsaedroSortField";

export const types = {
  string: "string",
  number: "number",
  boolean: "boolean",
  date: "date",
  datetime: "datetime",
  time: "time",
  pdf: "pdf",
  json: "json",
  allegato: "allegato",

  righe: "righe",
};

export function getType(
  field: ResourceField | FormField | ResourceViewField
): string {
  if (
    field.FormatType === undefined ||
    field.FormatType === FormatTypes.Generico
  ) {
    // @ts-ignore
    let fieldType = field.Field_Type
      ? // @ts-ignore
        field.Field_Type
      : // @ts-ignore
      field.FieldType
      ? // @ts-ignore
        field.FieldType
      : -1;

    let isDate = FieldTypes.date.find((n: number) => n === fieldType);
    if (isDate) return types.date;

    let isDateTime = FieldTypes.datetime.find((n: number) => n === fieldType);
    if (isDateTime) return types.datetime;

    let isNumber = FieldTypes.number.find((n: number) => n === fieldType);
    if (isNumber) return types.number;

    let isBoolean = FieldTypes.boolean.find((n: number) => n === fieldType);
    if (isBoolean) return types.boolean;

    let isTime = FieldTypes.time.find((n: number) => n === fieldType);
    if (isTime) return types.time;

    let isPdf = FieldTypes.pdf.find((n: number) => n === fieldType);
    if (isPdf) return types.pdf;

    let isJson = FieldTypes.json.find((n: number) => n === fieldType);
    if (isJson) return types.json;

    let isAllegato = FieldTypes.allegato.find((n: number) => n === fieldType);
    if (isAllegato) return types.allegato;

    let isRighe = FieldTypes.righe.find((n: number) => n === fieldType);
    if (isRighe) return types.righe;

    return types.string;
  } else {
    switch (field.FormatType) {
      case FormatTypes.Data:
        return types.date;
      case FormatTypes.DataOra:
        return types.datetime;
      case FormatTypes.SoloOra:
        return types.time;
      case FormatTypes.Importo:
        return types.string;
      case FormatTypes.Quantita:
        return types.string;
      case FormatTypes.Ditta:
        return types.string;
      case FormatTypes.Checkbox:
        return types.boolean;
      case FormatTypes.Articolo:
        return types.string;
      case FormatTypes.PrevMateriali:
        return types.string;
      case FormatTypes.Generico:
        return types.string;
      default:
        return types.string;
    }
  }
}

export function createBodyResourceFilterParams(
  resourceFilters?: EsaedroResourceFilter[],
  sortFileds?: EsaedroSortField[],
  menuItemId?: number,
  applyCustomFilter?: boolean
): string {
  let bodyObject: any = {};

  if (menuItemId) bodyObject.MenuItem_ID = menuItemId;
  if (applyCustomFilter !== undefined)
    bodyObject.ApplyCustomFilter = applyCustomFilter;

  if (resourceFilters && resourceFilters.length > 0) {
    bodyObject.ResourcesViewsFilters = [];

    resourceFilters.forEach((f: EsaedroResourceFilter) => {
      let tmpObj = {
        Filter_ID: f.Filter_ID,
        FieldName: f.FieldName,
        Operator: f.Operator,
        Value: f.Value,
        PreviousFilterOperator: f.previousFilterOperator,
      };

      bodyObject.ResourcesViewsFilters.push(tmpObj);
    });
  }

  if (sortFileds && sortFileds.length > 0) {
    bodyObject.ResourcesViewsSortFields = [];

    sortFileds.forEach((f: EsaedroSortField) => {
      let tmpObj = {
        FieldName: f.FieldName,
        SortType: f.SortType,
      };

      bodyObject.ResourcesViewsSortFields.push(tmpObj);
    });
  }

  let bodyString = JSON.stringify(bodyObject);

  return "[" + bodyString + "]";
}

export function createBodyResourceFilter(
  resourceFilters: EsaedroResourceFilter[],
  menuItemId?: number,
  applyCustomFilter?: boolean
) {
  var bodyString = "";

  if (menuItemId === undefined && applyCustomFilter === undefined) {
    /*
			[{
				"ResourcesViewsFilters" : [
					{
						"Filter_ID": 1,
						"FieldName": "Codice",
						"Operator": "Contains",
						"Value": "123"
					}
				]
			}]
		*/
    //Funzione utilizzata per create il body contenente i ResourcesViewsFilters utilizzata nella SituazioneUbicazione.tsx
    bodyString = "[{";

    if (resourceFilters.length > 0) {
      bodyString += '"ResourcesViewsFilters": [';
      resourceFilters.forEach((f: EsaedroResourceFilter) => {
        let tmpObj = {
          Filter_ID: f.Filter_ID,
          FieldName: f.FieldName,
          Operator: f.Operator,
          Value: f.Value,
        };

        let str_f = JSON.stringify(tmpObj);

        bodyString += str_f + ",";
      });

      bodyString = bodyString.substring(0, bodyString.length - 1);

      bodyString += "]}]";
    } else {
      bodyString += "}]";
    }
  } else if (menuItemId !== undefined && applyCustomFilter !== undefined) {
    //Funzione utilizzata per create il body contenente i ResourcesViewsFilters per la ObjectList
    bodyString =
      '[{"ApplyCustomFilter": "' +
      applyCustomFilter +
      '","MenuItem_ID": ' +
      menuItemId +
      "";

    if (resourceFilters.length > 0) {
      bodyString += ',"ResourcesViewsFilters": [';
      resourceFilters.forEach((f: EsaedroResourceFilter) => {
        let tmpObj = {
          Filter_ID: f.Filter_ID,
          FieldName: f.FieldName,
          Operator: f.Operator,
          Value: f.Value,
        };

        let str_f = JSON.stringify(tmpObj);

        bodyString += str_f + ",";
      });

      bodyString = bodyString.substring(0, bodyString.length - 1);

      bodyString += "]}]";
    } else {
      bodyString += "}]";
    }
  }

  return bodyString;
}

export function createEmptyObjectFromFormField(
  formFields: FormField[],
  customer_ID: number
) {
  var objToRet: any = {};
  if (formFields.length > 0) {
    formFields.forEach((field: FormField) => {
      switch (field.Field_Type) {
        case 1:
        case 2:
          objToRet[field.FieldName] = field.DefaultValue
            ? field.DefaultValue === "1"
              ? true
              : field.DefaultValue === "0"
              ? false
              : field.DefaultValue
            : false;
          break;
        default:
          objToRet[field.FieldName] = field.DefaultValue
            ? field.DefaultValue
            : undefined;
          break;
      }
    });

    objToRet.customer_ID = customer_ID;
  }
  return objToRet;
}

export function createEmptyObjectFromResourceField(
  resourceFields: ResourceField[],
  customer_ID: number
) {
  var objToRet: any = {};
  if (resourceFields.length > 0) {
    resourceFields.forEach((field: ResourceField) => {
      switch (field.Field_Type) {
        case 1:
        case 2:
          objToRet[field.FieldName] = field.DefaultValue
            ? field.DefaultValue === "1"
              ? true
              : field.DefaultValue === "0"
              ? false
              : field.DefaultValue
            : false;
          break;
        default:
          objToRet[field.FieldName] = field.DefaultValue
            ? field.DefaultValue
            : undefined;
          break;
      }
    });

    objToRet.customer_ID = customer_ID;
  }
  return objToRet;
}

export function getFormFields(form: Form) {
  let allFields: FormField[] = [];

  if (form && form.FormsGroups) {
    //Carico anche i Fields
    form.FormsGroups.forEach((group: FormGroup) => {
      //Ogni gruppo contiene dei fields che vanno filtrati con allFields e poi aggiunti -> FormFields
      if (group.FormsFields) {
        group.FormsFields.forEach((field: any) => {
          var isNew: boolean = true;

          //Filtraggio e verifica
          allFields.forEach((field2: FormField) => {
            if (field2.ResourceField_ID === field.ResourceField_ID)
              isNew = false;
          });

          if (isNew) allFields.push(field);
        });
      }
    });
  }

  return allFields;
}

export function isCubeAdmin(userProfile: UserProfile | undefined) {
  if (userProfile === undefined) return false;

  let cubeAdmin =
    userProfile.ProtectionLevel >= 99 ||
    (userProfile.Roles && userProfile.Roles.includes("sysadmin"))
      ? true
      : false;
  return cubeAdmin;
}

export function isCompanyAdmin(userProfile: UserProfile) {
  let cubeAdmin = isCubeAdmin(userProfile);
  let companyAdmin =
    !cubeAdmin && userProfile.ProtectionLevel >= 50 ? true : false;

  return companyAdmin;
}

export function canCreateUser(userProfile: UserProfile | undefined) {
  if (userProfile === undefined) return false;

  let cubeAdmin = isCubeAdmin(userProfile);
  let pl = userProfile.ProtectionLevel || 0;

  let canCreateUser = cubeAdmin || pl >= 10 ? true : false;

  return canCreateUser;
}

export const isCurrentTimeCell = (startDate: Date, endDate: Date): boolean => {
  const now = new Date();
  return now >= startDate && now <= endDate;
};

export function isItalianHoliday(date: Date): [boolean, string] {
  const fixedItalianHolidays: FixedItalianHolidays[] = [
    {
      name: "Capodanno",
      day: 1,
      month: 0,
    },
    {
      name: "Epifania",
      day: 6,
      month: 0,
    },
    {
      name: "Festa della Liberazione",
      day: 25,
      month: 3,
    },
    {
      name: "Festa del Lavoro",
      day: 1,
      month: 4,
    },
    {
      name: "Festa della Repubblica",
      day: 2,
      month: 5,
    },
    {
      name: "Assunzione di Maria",
      day: 15,
      month: 7,
    },
    {
      name: "Tutti i Santi",
      day: 1,
      month: 10,
    },
    {
      name: "Immacolata Concezione",
      day: 8,
      month: 11,
    },
    {
      name: "Natale",
      day: 25,
      month: 11,
    },
    {
      name: "Santo Stefano",
      day: 26,
      month: 11,
    },
  ];

  interface FixedItalianHolidays {
    name: string;
    day: number;
    month: number;
  }

  const isFixedItalianHoliday = (
    date: Date,
    fixedItalianHolidays: FixedItalianHolidays[]
  ): [boolean, string] => {
    const dateDay = date.getDate();
    const dateMonth = date.getMonth();

    for (const fixedItalianHoliday of fixedItalianHolidays) {
      if (
        fixedItalianHoliday.day === dateDay &&
        fixedItalianHoliday.month === dateMonth
      ) {
        return [true, fixedItalianHoliday.name];
      }
    }

    return [false, ""];
  };

  const isEaster = (date: Date): [boolean, string] => {
    const year = date.getFullYear();

    // Calcolo della data di Pasqua secondo l'algoritmo di Gauss
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const n = Math.floor((h + l - 7 * m + 114) / 31);
    const p = (h + l - 7 * m + 114) % 31;

    const easterMonth = n - 1; // Mese di Pasqua (0-based index)
    const easterDay = p + 1; // Giorno di Pasqua

    // Confronto la data selezionata con la data di Pasqua
    if (date.getMonth() === easterMonth && date.getDate() === easterDay) {
      return [true, "Pasqua"];
    } else {
      return [false, ""];
    }
  };

  const isEasterMonday = (date: Date): [boolean, string] => {
    const previousDate = new Date(date.getTime() - 24 * 60 * 60 * 1000);

    if (isEaster(previousDate)[0]) {
      return [true, "Pasquetta"];
    }
    return [false, ""];
  };

  const fns: [boolean, string][] = [
    isFixedItalianHoliday(date, fixedItalianHolidays),
    // isEaster(date),
    isEasterMonday(date),
  ];

  for (const fn of fns) {
    const result = fn;

    if (result[0]) {
      return result;
    }
  }
  return [false, ""];
}

// This function is used to convert a date in ISO8601 format string (YYYY-MM-DD)
export const convertDateToISO8601 = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// This function is used to convert a date in string (DD/MM/YYYY)
export const convertDateToHumanReadable = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;
};

export const convertHoursToTimeString = (hours: number): string => {
  const wholeHours: number = Math.floor(hours);
  const minutes: number = Math.round((hours - wholeHours) * 60);

  const timeString: string = `${wholeHours
    .toString()
    .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

  return timeString;
};
